module.exports = __webpack_public_path__ + "img/payslip.0bbd541a.png";